import React from 'react';
import { motion } from "framer-motion/dist/framer-motion";
import {
  slide_bounce_down_variants
} from "shared/components/animations";
import cancelBtn from "assets/images/och/cancel-btn.png";
import clubs from "assets/images/och/clubs.png";
import heart from "assets/images/och/suit1.png";
import spades from "assets/images/och/spades.png";
import diamond from "assets/images/och/diamond.png";

const CardOptionBox = ({ chooseSuit,onClose=()=>{} }) => {
  const selectSuit = (data) => {
    chooseSuit(data);
  };

  return (
    <motion.div variants={slide_bounce_down_variants} className='card-options'>
      <p className='text'>Choose your new suit</p>
      <div className='suit-flex'>
        <img src={spades} className='img-fluid' alt="" onClick={() => selectSuit("spades")} />
        <img src={heart} className='img-fluid' alt="" onClick={() => selectSuit("hearts")} />
        <img src={clubs} className='img-fluid' alt="" onClick={() => selectSuit("clubs")} />
        <img src={diamond} className='img-fluid' alt="" onClick={() => selectSuit("diamonds")} />
      </div>
      <img src={cancelBtn} onClick={()=>onClose()} className='img-fluid' alt="" />
    </motion.div>
  );
};

export default CardOptionBox;
